import { useEffect } from 'react';
import './home.css';
import HomeNav from './components/HomeNav';
import Hero from './components/Hero';
import Collection from './components/Collection';
import SignatureMenu from './components/SignatureMenu';
import Timeline from './components/Timeline';
import Craft from './components/Craft';
import VisitFooter from './components/VisitFooter';

export default function HomePage() {
  useEffect(() => {
    document.title = 'FOLD. — Artisan Bakery, Made in Layers';
    const desc = document.querySelector('meta[name="description"]');
    const text = 'FOLD. is a contemporary artisan bakery: hand-laminated croissants and naturally leavened sourdough, baked in small batches and made in layers. Pickup only.';
    if (desc) desc.setAttribute('content', text);
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="fold-home">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] focus:bg-[#F5F1EB] focus:px-4 focus:py-2">
        Skip to content
      </a>
      <HomeNav />
      <main id="main">
        <Hero />
        <Collection />
        <SignatureMenu />
        <Timeline />
        <Craft />
        <VisitFooter />
      </main>
    </div>
  );
}